var _style, _path, _g, _g2, _path2, _g3, _g4, _path3, _g5, _g6, _path4, _g7, _g8, _path5, _g9, _g0, _path6, _g1, _g10, _path7, _g11, _g12, _path8, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87 263",
    style: {
      enableBackground: "new 0 0 87 263"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2F4E2B;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;}\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.2,20.7H7.3c-3.5,0-6.3-2.8-6.3-6.3V7.3C1,3.8,3.8,1,7.3,1h71.9c3.5,0,6.3,2.8,6.3,6.3v7.1 C85.5,17.9,82.7,20.7,79.2,20.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.6,12.5l0.6-0.8c0.4,0.3,0.9,0.5,1.3,0.5c0.5,0,0.7-0.2,0.7-0.5c0-0.3-0.3-0.4-0.7-0.6l-0.7-0.3 c-0.5-0.2-1-0.7-1-1.4c0-0.9,0.8-1.6,1.9-1.6c0.6,0,1.2,0.2,1.7,0.6l-0.6,0.8c-0.3-0.2-0.7-0.4-1-0.4c-0.4,0-0.6,0.2-0.6,0.4 c0,0.3,0.3,0.4,0.8,0.6l0.6,0.3c0.6,0.3,1,0.7,1,1.4c0,0.9-0.7,1.6-2,1.6C9.8,13.2,9.1,13,8.6,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.2,11.6V9.2h1.2v2.3c0,0.5,0.1,0.7,0.5,0.7c0.3,0,0.4-0.1,0.7-0.4V9.2h1.2v3.9h-1l-0.1-0.5h0 c-0.3,0.4-0.7,0.6-1.2,0.6C13.5,13.2,13.2,12.6,13.2,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.8,12.7L18.8,12.7l-0.1,0.4h-1V7.6H19v1.3l0,0.6c0.3-0.3,0.6-0.4,1-0.4c0.9,0,1.5,0.8,1.5,2 c0,1.4-0.8,2.1-1.6,2.1C19.5,13.2,19.1,13,18.8,12.7z M20.2,11.1c0-0.7-0.2-1-0.6-1c-0.2,0-0.4,0.1-0.6,0.3V12 c0.2,0.2,0.4,0.2,0.6,0.2C19.9,12.2,20.2,11.9,20.2,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.3,9.2h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.2-0.6c0.5,0,0.9,0.2,1.1,0.6c0.3-0.3,0.7-0.6,1.2-0.6 c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.2-0.7-0.5-0.7c-0.2,0-0.4,0.1-0.6,0.4v2.6h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.2,0-0.4,0.1-0.6,0.4v2.6h-1.2V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29,8c0-0.4,0.3-0.6,0.7-0.6c0.4,0,0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6C29.3,8.6,29,8.4,29,8z M29.1,9.2 h1.2v3.9h-1.2V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.5,11.7v-1.5h-0.5V9.2l0.6,0L31.7,8h1v1.2h0.9v1h-0.9v1.5c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1 l0.2,0.9c-0.2,0.1-0.5,0.2-0.9,0.2C31.9,13.2,31.5,12.6,31.5,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.1,8h1.2v5.1h-1.2V8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.4,9.2h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.1,11.7v-1.5h-0.5V9.2l0.6,0L43.3,8h1v1.2h0.9v1h-0.9v1.5c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1 l0.2,0.9c-0.2,0.1-0.5,0.2-0.9,0.2C43.5,13.2,43.1,12.6,43.1,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.7,12c0-0.8,0.6-1.3,2.2-1.4c0-0.3-0.2-0.5-0.6-0.5c-0.3,0-0.6,0.1-1,0.3l-0.4-0.8c0.5-0.3,1.1-0.5,1.7-0.5 c1,0,1.6,0.6,1.6,1.8v2.2h-1L48,12.7h0c-0.3,0.3-0.7,0.5-1.1,0.5C46.1,13.2,45.7,12.7,45.7,12z M47.9,12v-0.6c-0.8,0.1-1,0.3-1,0.6 c0,0.2,0.2,0.3,0.4,0.3C47.5,12.3,47.7,12.2,47.9,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50,7.6h1.2v3.1h0l1.2-1.5h1.3l-1.4,1.6l1.5,2.3h-1.3l-0.9-1.5l-0.5,0.5v1H50V7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54,11.2c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5h-2.3c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C54.8,13.2,54,12.5,54,11.2z M56.5,10.7c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60,8h3.3v1h-2.1v1.1H63v1h-1.8v2H60V8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.7,11.2c0-1.3,0.9-2.1,1.9-2.1c1,0,1.9,0.8,1.9,2.1c0,1.3-0.9,2.1-1.9,2.1C64.6,13.2,63.7,12.5,63.7,11.2z  M66.3,11.2c0-0.6-0.2-1.1-0.7-1.1c-0.5,0-0.7,0.4-0.7,1.1c0,0.7,0.2,1.1,0.7,1.1C66.1,12.2,66.3,11.8,66.3,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.3,9.2h1l0.1,0.7h0c0.3-0.5,0.7-0.8,1.1-0.8c0.2,0,0.4,0,0.5,0.1l-0.2,1c-0.1,0-0.2,0-0.4,0 c-0.3,0-0.6,0.2-0.9,0.7v2.2h-1.2V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.5,9.2h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.2-0.6c0.5,0,0.9,0.2,1.1,0.6c0.3-0.3,0.7-0.6,1.2-0.6 c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.2-0.7-0.5-0.7c-0.2,0-0.4,0.1-0.6,0.4v2.6h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.2,0-0.4,0.1-0.6,0.4v2.6h-1.2V9.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 43.2,
    y1: 20.7,
    x2: 43.2,
    y2: 35.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 43.2,
    y1: 20.7,
    x2: 43.2,
    y2: 30.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "41.7,29.6 43.2,35.4 44.8,29.6  "
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.2,55H7.3C3.8,55,1,52.2,1,48.8v-7.1c0-3.5,2.8-6.3,6.3-6.3h71.9c3.5,0,6.3,2.8,6.3,6.3v7.1 C85.5,52.2,82.7,55,79.2,55z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.1,46.8l0.6-0.8c0.4,0.3,0.9,0.5,1.3,0.5c0.5,0,0.7-0.2,0.7-0.5c0-0.3-0.3-0.4-0.7-0.6l-0.7-0.3 c-0.5-0.2-1-0.7-1-1.4c0-0.9,0.8-1.6,1.9-1.6c0.6,0,1.2,0.2,1.7,0.6l-0.6,0.8c-0.3-0.2-0.7-0.4-1-0.4c-0.4,0-0.6,0.2-0.6,0.4 c0,0.3,0.3,0.4,0.8,0.6l0.6,0.3c0.6,0.3,1,0.7,1,1.4c0,0.9-0.7,1.6-2,1.6C16.3,47.6,15.6,47.3,15.1,46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.7,42.4c0-0.4,0.3-0.6,0.7-0.6c0.4,0,0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6C19.9,43,19.7,42.8,19.7,42.4z  M19.7,43.6h1.2v3.9h-1.2V43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.1,46v-1.5h-0.5v-0.9l0.6,0l0.1-1.2h1v1.2h0.9v1h-0.9V46c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1 l0.2,0.9c-0.2,0.1-0.5,0.2-0.9,0.2C22.5,47.6,22.1,47,22.1,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.6,45.5c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5h-2.3c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C25.5,47.6,24.6,46.8,24.6,45.5z M27.1,45.1c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.6,42.3h1.5l1.6,5.1h-1.3l-0.3-1.2h-1.5l-0.3,1.2H30L31.6,42.3z M31.8,45.4h1.1l-0.1-0.4 c-0.1-0.5-0.3-1.1-0.4-1.7h0c-0.1,0.5-0.3,1.1-0.4,1.7L31.8,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.9,47l0.5-0.7c0.4,0.3,0.7,0.4,1,0.4c0.3,0,0.5-0.1,0.5-0.3c0-0.2-0.3-0.3-0.8-0.5c-0.6-0.2-1-0.6-1-1.2 c0-0.7,0.6-1.2,1.5-1.2c0.6,0,1.1,0.2,1.4,0.5l-0.5,0.7c-0.3-0.2-0.6-0.3-0.8-0.3c-0.3,0-0.4,0.1-0.4,0.3c0,0.2,0.2,0.3,0.7,0.5 c0.6,0.2,1.1,0.5,1.1,1.2c0,0.7-0.6,1.3-1.6,1.3C35.9,47.6,35.3,47.4,34.9,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.4,47l0.5-0.7c0.4,0.3,0.7,0.4,1,0.4c0.3,0,0.5-0.1,0.5-0.3c0-0.2-0.3-0.3-0.8-0.5c-0.6-0.2-1-0.6-1-1.2 c0-0.7,0.6-1.2,1.5-1.2c0.6,0,1.1,0.2,1.4,0.5L41,44.7c-0.3-0.2-0.6-0.3-0.8-0.3c-0.3,0-0.4,0.1-0.4,0.3c0,0.2,0.2,0.3,0.7,0.5 c0.6,0.2,1.1,0.5,1.1,1.2c0,0.7-0.6,1.3-1.6,1.3C39.4,47.6,38.8,47.4,38.4,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42,45.5c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5h-2.3c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C42.9,47.6,42,46.8,42,45.5z M44.5,45.1c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46,47l0.5-0.7c0.4,0.3,0.7,0.4,1,0.4c0.3,0,0.5-0.1,0.5-0.3c0-0.2-0.3-0.3-0.8-0.5c-0.6-0.2-1-0.6-1-1.2 c0-0.7,0.6-1.2,1.5-1.2c0.6,0,1.1,0.2,1.4,0.5l-0.5,0.7c-0.3-0.2-0.6-0.3-0.8-0.3c-0.3,0-0.4,0.1-0.4,0.3c0,0.2,0.2,0.3,0.7,0.5 c0.6,0.2,1.1,0.5,1.1,1.2c0,0.7-0.6,1.3-1.6,1.3C47,47.6,46.4,47.4,46,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.6,47l0.5-0.7c0.4,0.3,0.7,0.4,1,0.4c0.3,0,0.5-0.1,0.5-0.3c0-0.2-0.3-0.3-0.8-0.5c-0.6-0.2-1-0.6-1-1.2 c0-0.7,0.6-1.2,1.5-1.2c0.6,0,1.1,0.2,1.4,0.5l-0.5,0.7c-0.3-0.2-0.6-0.3-0.8-0.3c-0.3,0-0.4,0.1-0.4,0.3c0,0.2,0.2,0.3,0.7,0.5 c0.6,0.2,1.1,0.5,1.1,1.2c0,0.7-0.6,1.3-1.6,1.3C50.5,47.6,49.9,47.4,49.6,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.4,43.6h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.2-0.6c0.5,0,0.9,0.2,1.1,0.6c0.3-0.3,0.7-0.6,1.2-0.6 c0.9,0,1.2,0.6,1.2,1.6v2.4H58v-2.3c0-0.5-0.2-0.7-0.5-0.7c-0.2,0-0.4,0.1-0.6,0.4v2.6h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.2,0-0.4,0.1-0.6,0.4v2.6h-1.2V43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60,45.5c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5h-2.3c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C60.9,47.6,60,46.8,60,45.5z M62.5,45.1c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.3,43.6h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69,46v-1.5h-0.5v-0.9l0.6,0l0.1-1.2h1v1.2h0.9v1h-0.9V46c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1l0.2,0.9 c-0.2,0.1-0.5,0.2-0.9,0.2C69.4,47.6,69,47,69,46z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 43.2,
    y1: 55,
    x2: 43.2,
    y2: 69.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 43.2,
    y1: 55,
    x2: 43.2,
    y2: 65
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "41.7,64 43.2,69.7 44.8,64  "
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.2,89.4H7.3c-3.5,0-6.3-2.8-6.3-6.3V76c0-3.5,2.8-6.3,6.3-6.3h71.9c3.5,0,6.3,2.8,6.3,6.3v7.1 C85.5,86.6,82.7,89.4,79.2,89.4z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.4,76.7h1.8c1.1,0,2.1,0.4,2.1,1.7c0,1.2-0.9,1.8-2,1.8h-0.6v1.7h-1.2V76.7z M25.2,79.2 c0.6,0,0.9-0.3,0.9-0.8s-0.3-0.7-0.9-0.7h-0.5v1.5H25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.1,80.6v-4.3h1.2v4.3c0,0.3,0.1,0.3,0.2,0.3c0,0,0.1,0,0.1,0l0.1,0.9c-0.1,0.1-0.3,0.1-0.6,0.1 C28.3,82,28.1,81.4,28.1,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.2,80.8c0-0.8,0.6-1.3,2.2-1.4c0-0.3-0.2-0.5-0.6-0.5c-0.3,0-0.6,0.1-1,0.3l-0.4-0.8 c0.5-0.3,1.1-0.5,1.7-0.5c1,0,1.6,0.6,1.6,1.8v2.2h-1l-0.1-0.4h0c-0.3,0.3-0.7,0.5-1.1,0.5C30.6,82,30.2,81.4,30.2,80.8z  M32.4,80.7v-0.6c-0.8,0.1-1,0.3-1,0.6c0,0.2,0.2,0.3,0.4,0.3C32,81,32.2,80.9,32.4,80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.5,77.9h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.8,76.7h1.5c1.6,0,2.6,0.8,2.6,2.6c0,1.8-1,2.6-2.5,2.6h-1.5V76.7z M42.2,80.9c0.8,0,1.4-0.4,1.4-1.6 c0-1.2-0.6-1.6-1.4-1.6H42v3.2H42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.5,79.9c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5h-2.3c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C46.3,82,45.5,81.2,45.5,79.9z M48,79.4c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.5,81.4l0.5-0.7c0.4,0.3,0.7,0.4,1,0.4c0.3,0,0.5-0.1,0.5-0.3c0-0.2-0.3-0.3-0.8-0.5c-0.6-0.2-1-0.6-1-1.2 c0-0.7,0.6-1.2,1.5-1.2c0.6,0,1.1,0.2,1.4,0.5L52.1,79c-0.3-0.2-0.6-0.3-0.8-0.3c-0.3,0-0.4,0.1-0.4,0.3c0,0.2,0.2,0.3,0.7,0.5 c0.6,0.2,1.1,0.5,1.1,1.2c0,0.7-0.6,1.3-1.6,1.3C50.5,82,49.9,81.8,49.5,81.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.3,76.7c0-0.4,0.3-0.6,0.7-0.6s0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6S53.3,77.1,53.3,76.7z M53.3,77.9h1.2 v3.9h-1.2V77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.3,82.5c0-0.3,0.2-0.6,0.6-0.8v0c-0.2-0.1-0.4-0.3-0.4-0.7c0-0.3,0.2-0.6,0.4-0.7v0c-0.3-0.2-0.5-0.6-0.5-1 c0-1,0.8-1.4,1.6-1.4c0.2,0,0.4,0,0.6,0.1h1.4v0.9h-0.6c0.1,0.1,0.1,0.3,0.1,0.5c0,0.9-0.7,1.3-1.6,1.3c-0.1,0-0.3,0-0.5-0.1 c-0.1,0.1-0.1,0.1-0.1,0.3c0,0.2,0.2,0.3,0.6,0.3h0.6c1,0,1.5,0.3,1.5,1c0,0.8-0.9,1.4-2.2,1.4C56,83.5,55.3,83.2,55.3,82.5z  M58,82.3c0-0.2-0.2-0.3-0.6-0.3h-0.4c-0.3,0-0.4,0-0.6,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.3,0.3,0.4,0.8,0.4 C57.7,82.8,58,82.6,58,82.3z M57.6,79.3c0-0.4-0.2-0.6-0.5-0.6c-0.3,0-0.5,0.2-0.5,0.6c0,0.4,0.2,0.6,0.5,0.6 C57.4,79.9,57.6,79.7,57.6,79.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.8,77.9h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V77.9z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 43.2,
    y1: 89.4,
    x2: 43.2,
    y2: 104.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 43.2,
    y1: 89.4,
    x2: 43.2,
    y2: 99.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "41.7,98.4 43.2,104.1 44.8,98.4  "
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.2,123.8H7.3c-3.5,0-6.3-2.8-6.3-6.3v-7.1c0-3.5,2.8-6.3,6.3-6.3h71.9c3.5,0,6.3,2.8,6.3,6.3v7.1 C85.5,121,82.7,123.8,79.2,123.8z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.5,113.7c0-1.7,1.2-2.7,2.5-2.7c0.7,0,1.2,0.3,1.6,0.7l-0.6,0.7c-0.3-0.2-0.5-0.4-0.9-0.4 c-0.7,0-1.2,0.6-1.2,1.6c0,1,0.5,1.6,1.2,1.6c0.4,0,0.7-0.2,1-0.4l0.6,0.7c-0.5,0.5-1,0.8-1.7,0.8C6.6,116.3,5.5,115.4,5.5,113.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10,114.3c0-1.3,0.9-2.1,1.9-2.1c1,0,1.9,0.8,1.9,2.1c0,1.3-0.9,2.1-1.9,2.1C10.9,116.3,10,115.6,10,114.3z  M12.6,114.3c0-0.6-0.2-1.1-0.7-1.1s-0.7,0.4-0.7,1.1c0,0.7,0.2,1.1,0.7,1.1S12.6,114.9,12.6,114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.6,112.3h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4H17V114c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.8,115.7l0.5-0.7c0.4,0.3,0.7,0.4,1,0.4c0.3,0,0.5-0.1,0.5-0.3c0-0.2-0.3-0.3-0.8-0.5c-0.6-0.2-1-0.6-1-1.2 c0-0.7,0.6-1.2,1.5-1.2c0.6,0,1.1,0.2,1.4,0.5l-0.5,0.7c-0.3-0.2-0.6-0.3-0.8-0.3c-0.3,0-0.4,0.1-0.4,0.3c0,0.2,0.2,0.3,0.7,0.5 c0.6,0.2,1.1,0.5,1.1,1.2c0,0.7-0.6,1.3-1.6,1.3C19.8,116.3,19.2,116.1,18.8,115.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.6,114.7v-2.4h1.2v2.3c0,0.5,0.1,0.7,0.5,0.7c0.3,0,0.4-0.1,0.7-0.4v-2.6h1.2v3.9h-1l-0.1-0.5h0 c-0.3,0.4-0.7,0.6-1.2,0.6C23,116.3,22.6,115.7,22.6,114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.2,115v-4.3h1.2v4.3c0,0.3,0.1,0.3,0.2,0.3c0,0,0.1,0,0.1,0l0.1,0.9c-0.1,0.1-0.3,0.1-0.6,0.1 C27.5,116.3,27.2,115.8,27.2,115z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.7,114.8v-1.5h-0.5v-0.9l0.6,0l0.1-1.2h1v1.2h0.9v1h-0.9v1.5c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1 l0.2,0.9c-0.2,0.1-0.5,0.2-0.9,0.2C30.1,116.3,29.7,115.7,29.7,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34,115.1c0-0.8,0.6-1.3,2.2-1.4c0-0.3-0.2-0.5-0.6-0.5c-0.3,0-0.6,0.1-1,0.3l-0.4-0.8 c0.5-0.3,1.1-0.5,1.7-0.5c1,0,1.6,0.6,1.6,1.8v2.2h-1l-0.1-0.4h0c-0.3,0.3-0.7,0.5-1.1,0.5C34.4,116.3,34,115.8,34,115.1z  M36.2,115.1v-0.6c-0.8,0.1-1,0.3-1,0.6c0,0.2,0.2,0.3,0.4,0.3C35.8,115.4,36,115.3,36.2,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.3,112.3h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2V114c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.7,114.3c0-1.3,0.8-2.1,1.6-2.1c0.4,0,0.7,0.2,0.9,0.4l0-0.6v-1.3h1.2v5.5h-1l-0.1-0.4h0 c-0.3,0.3-0.7,0.5-1,0.5C43.3,116.3,42.7,115.5,42.7,114.3z M45.2,115v-1.6c-0.2-0.2-0.4-0.2-0.6-0.2c-0.3,0-0.7,0.3-0.7,1.1 c0,0.8,0.3,1.1,0.7,1.1C44.9,115.3,45,115.2,45.2,115z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.1,111.1h1.8c1.1,0,2.1,0.4,2.1,1.7c0,1.2-0.9,1.8-2,1.8h-0.6v1.7h-1.2V111.1z M50.9,113.5 c0.6,0,0.9-0.3,0.9-0.8s-0.3-0.7-0.9-0.7h-0.5v1.5H50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.8,112.3h1l0.1,0.7h0c0.3-0.5,0.7-0.8,1.1-0.8c0.2,0,0.4,0,0.5,0.1l-0.2,1c-0.1,0-0.2,0-0.4,0 c-0.3,0-0.6,0.2-0.9,0.7v2.2h-1.2V112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.9,111.1c0-0.4,0.3-0.6,0.7-0.6c0.4,0,0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6 C57.2,111.7,56.9,111.5,56.9,111.1z M57,112.3h1.2v3.9H57V112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59,114.3c0-1.3,0.9-2.1,1.9-2.1c1,0,1.9,0.8,1.9,2.1c0,1.3-0.9,2.1-1.9,2.1C59.9,116.3,59,115.6,59,114.3z  M61.5,114.3c0-0.6-0.2-1.1-0.7-1.1c-0.5,0-0.7,0.4-0.7,1.1c0,0.7,0.2,1.1,0.7,1.1C61.3,115.3,61.5,114.9,61.5,114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.6,112.3h1l0.1,0.7h0c0.3-0.5,0.7-0.8,1.1-0.8c0.2,0,0.4,0,0.5,0.1l-0.2,1c-0.1,0-0.2,0-0.4,0 c-0.3,0-0.6,0.2-0.9,0.7v2.2h-1.2V112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.7,111.1c0-0.4,0.3-0.6,0.7-0.6c0.4,0,0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6 C67,111.7,66.7,111.5,66.7,111.1z M66.8,112.3H68v3.9h-1.2V112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.2,114.8v-1.5h-0.5v-0.9l0.6,0l0.1-1.2h1v1.2h0.9v1h-0.9v1.5c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1 l0.2,0.9c-0.2,0.1-0.5,0.2-0.9,0.2C69.6,116.3,69.2,115.7,69.2,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72,111.1c0-0.4,0.3-0.6,0.7-0.6s0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6S72,111.5,72,111.1z M72.1,112.3h1.2 v3.9h-1.2V112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.1,115.6l1.6-2.3h-1.4v-1h2.9v0.7l-1.6,2.3h1.7v1h-3.2V115.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.7,114.3c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5h-2.3c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C78.5,116.3,77.7,115.6,77.7,114.3z M80.2,113.8c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H80.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 43.2,
    y1: 123.8,
    x2: 43.2,
    y2: 138.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 43.2,
    y1: 123.8,
    x2: 43.2,
    y2: 133.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "41.7,132.7 43.2,138.5 44.8,132.7  "
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.2,158.1H7.3c-3.5,0-6.3-2.8-6.3-6.3v-7.1c0-3.5,2.8-6.3,6.3-6.3h71.9c3.5,0,6.3,2.8,6.3,6.3v7.1 C85.5,155.3,82.7,158.1,79.2,158.1z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.4,149.9l0.6-0.8c0.4,0.3,0.9,0.5,1.3,0.5c0.5,0,0.7-0.2,0.7-0.5c0-0.3-0.3-0.4-0.7-0.6l-0.7-0.3 c-0.5-0.2-1-0.7-1-1.4c0-0.9,0.8-1.6,1.9-1.6c0.6,0,1.2,0.2,1.7,0.6l-0.6,0.8c-0.3-0.2-0.7-0.4-1-0.4c-0.4,0-0.6,0.2-0.6,0.4 c0,0.3,0.3,0.4,0.8,0.6l0.6,0.3c0.6,0.3,1,0.7,1,1.4c0,0.9-0.7,1.6-2,1.6C18.6,150.7,17.9,150.5,17.4,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.8,148.6c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5H23c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C22.7,150.7,21.8,149.9,21.8,148.6z M24.3,148.2c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.1,149.3v-4.3h1.2v4.3c0,0.3,0.1,0.3,0.2,0.3c0,0,0.1,0,0.1,0l0.1,0.9c-0.1,0.1-0.3,0.1-0.6,0.1 C26.4,150.7,26.1,150.1,26.1,149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.2,148.6c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5h-2.3c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C29.1,150.7,28.2,149.9,28.2,148.6z M30.7,148.2c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.3,148.6c0-1.3,1-2.1,2.1-2.1c0.5,0,0.9,0.2,1.1,0.4l-0.6,0.8c-0.2-0.1-0.3-0.2-0.5-0.2 c-0.5,0-0.9,0.4-0.9,1.1c0,0.7,0.4,1.1,0.8,1.1c0.3,0,0.5-0.1,0.7-0.2l0.5,0.8c-0.4,0.3-0.9,0.5-1.3,0.5 C33.2,150.7,32.3,149.9,32.3,148.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.3,149.1v-1.5h-0.5v-0.9l0.6,0l0.1-1.2h1v1.2h0.9v1h-0.9v1.5c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1 l0.2,0.9c-0.2,0.1-0.5,0.2-0.9,0.2C36.7,150.7,36.3,150.1,36.3,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.9,145.5h3.3v1h-2.1v1.1h1.8v1h-1.8v2h-1.2V145.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.8,149.1v-2.4H46v2.3c0,0.5,0.1,0.7,0.5,0.7c0.3,0,0.4-0.1,0.7-0.4v-2.6h1.2v3.9h-1l-0.1-0.5h0 c-0.3,0.4-0.7,0.6-1.2,0.6C45.2,150.7,44.8,150.1,44.8,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.4,146.7h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.7,148.6c0-1.3,0.8-2.1,1.6-2.1c0.4,0,0.7,0.2,0.9,0.4l0-0.6v-1.3h1.2v5.5h-1l-0.1-0.4h0 c-0.3,0.3-0.7,0.5-1,0.5C54.4,150.7,53.7,149.9,53.7,148.6z M56.3,149.4v-1.6c-0.2-0.2-0.4-0.2-0.6-0.2c-0.3,0-0.7,0.3-0.7,1.1 c0,0.8,0.3,1.1,0.7,1.1C55.9,149.7,56.1,149.6,56.3,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.4,145.5c0-0.4,0.3-0.6,0.7-0.6c0.4,0,0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6 C58.7,146.1,58.4,145.9,58.4,145.5z M58.5,146.7h1.2v3.9h-1.2V146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.7,146.7h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4H63v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65,151.3c0-0.3,0.2-0.6,0.6-0.8v0c-0.2-0.1-0.4-0.3-0.4-0.7c0-0.3,0.2-0.6,0.4-0.7v0c-0.3-0.2-0.5-0.6-0.5-1 c0-1,0.8-1.4,1.6-1.4c0.2,0,0.4,0,0.6,0.1h1.4v0.9h-0.6c0.1,0.1,0.1,0.3,0.1,0.5c0,0.9-0.7,1.3-1.6,1.3c-0.1,0-0.3,0-0.5-0.1 c-0.1,0.1-0.1,0.1-0.1,0.3c0,0.2,0.2,0.3,0.6,0.3h0.6c1,0,1.5,0.3,1.5,1c0,0.8-0.9,1.4-2.2,1.4C65.7,152.3,65,152,65,151.3z  M67.7,151c0-0.2-0.2-0.3-0.6-0.3h-0.4c-0.3,0-0.4,0-0.6,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.3,0.3,0.4,0.8,0.4 C67.3,151.5,67.7,151.3,67.7,151z M67.2,148c0-0.4-0.2-0.6-0.5-0.6c-0.3,0-0.5,0.2-0.5,0.6c0,0.4,0.2,0.6,0.5,0.6 C67,148.6,67.2,148.4,67.2,148z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 43.2,
    y1: 158.1,
    x2: 43.2,
    y2: 172.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 43.2,
    y1: 158.1,
    x2: 43.2,
    y2: 168.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "41.7,167.1 43.2,172.8 44.8,167.1  "
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.2,192.5H7.3c-3.5,0-6.3-2.8-6.3-6.3v-7.1c0-3.5,2.8-6.3,6.3-6.3h71.9c3.5,0,6.3,2.8,6.3,6.3v7.1 C85.5,189.7,82.7,192.5,79.2,192.5z"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.4,179.8h1.2v5.1h-1.2V179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.7,181h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.2-0.6c0.5,0,0.9,0.2,1.1,0.6c0.3-0.3,0.7-0.6,1.2-0.6 c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7c-0.2,0-0.4,0.1-0.6,0.4v2.6H20v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.2,0-0.4,0.1-0.6,0.4v2.6h-1.2V181z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.5,181h1l0.1,0.4h0c0.3-0.3,0.7-0.5,1.1-0.5c0.9,0,1.5,0.8,1.5,2c0,1.4-0.8,2.1-1.6,2.1 c-0.3,0-0.6-0.1-0.9-0.4l0,0.6v1.1h-1.2V181z M27,183c0-0.7-0.2-1-0.6-1c-0.2,0-0.4,0.1-0.6,0.3v1.6c0.2,0.2,0.4,0.2,0.6,0.2 C26.7,184.1,27,183.8,27,183z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29,183.7v-4.3h1.2v4.3c0,0.3,0.1,0.3,0.2,0.3c0,0,0.1,0,0.1,0l0.1,0.9c-0.1,0.1-0.3,0.1-0.6,0.1 C29.3,185.1,29,184.5,29,183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.1,183c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5h-2.3c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C32,185.1,31.1,184.3,31.1,183z M33.6,182.5c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.4,181h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.2-0.6c0.5,0,0.9,0.2,1.1,0.6c0.3-0.3,0.7-0.6,1.2-0.6 c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.2-0.7-0.5-0.7c-0.2,0-0.4,0.1-0.6,0.4v2.6h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.2,0-0.4,0.1-0.6,0.4v2.6h-1.2V181z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42,183c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5h-2.3c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C42.9,185.1,42,184.3,42,183z M44.5,182.5c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.4,181h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V181z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.1,183.5V182h-0.5v-0.9l0.6,0l0.1-1.2h1v1.2h0.9v1h-0.9v1.5c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1 l0.2,0.9c-0.2,0.1-0.5,0.2-0.9,0.2C51.5,185.1,51.1,184.4,51.1,183.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.6,183.9c0-0.8,0.6-1.3,2.2-1.4c0-0.3-0.2-0.5-0.6-0.5c-0.3,0-0.6,0.1-1,0.3l-0.4-0.8 c0.5-0.3,1.1-0.5,1.7-0.5c1,0,1.6,0.6,1.6,1.8v2.2h-1l-0.1-0.4h0c-0.3,0.3-0.7,0.5-1.1,0.5C54.1,185.1,53.6,184.5,53.6,183.9z  M55.8,183.8v-0.6c-0.8,0.1-1,0.3-1,0.6c0,0.2,0.2,0.3,0.4,0.3C55.5,184.1,55.6,184,55.8,183.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58,183.5V182h-0.5v-0.9l0.6,0l0.1-1.2h1v1.2h0.9v1h-0.9v1.5c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1 l0.2,0.9c-0.2,0.1-0.5,0.2-0.9,0.2C58.4,185.1,58,184.4,58,183.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.8,179.9c0-0.4,0.3-0.6,0.7-0.6s0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6S60.8,180.2,60.8,179.9z M60.9,181 h1.2v3.9h-1.2V181z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.9,183c0-1.3,0.9-2.1,1.9-2.1c1,0,1.9,0.8,1.9,2.1c0,1.3-0.9,2.1-1.9,2.1C63.8,185.1,62.9,184.3,62.9,183z  M65.5,183c0-0.6-0.2-1.1-0.7-1.1c-0.5,0-0.7,0.4-0.7,1.1c0,0.7,0.2,1.1,0.7,1.1C65.3,184.1,65.5,183.7,65.5,183z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.5,181h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V181z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 43.2,
    y1: 192.5,
    x2: 43.2,
    y2: 207.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 43.2,
    y1: 192.5,
    x2: 43.2,
    y2: 202.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "41.7,201.5 43.2,207.2 44.8,201.5  "
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.2,226.9H7.3c-3.5,0-6.3-2.8-6.3-6.3v-7.1c0-3.5,2.8-6.3,6.3-6.3h71.9c3.5,0,6.3,2.8,6.3,6.3v7.1 C85.5,224.1,82.7,226.9,79.2,226.9z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.3,214.2h1.3l0.8,2.2c0.1,0.3,0.2,0.6,0.3,0.9h0c0.1-0.3,0.2-0.6,0.3-0.9l0.8-2.2h1.3v5.1h-1.1v-1.8 c0-0.5,0.1-1.4,0.2-1.9h0l-0.4,1.3l-0.7,1.9h-0.7l-0.7-1.9l-0.4-1.3h0c0.1,0.5,0.2,1.4,0.2,1.9v1.8h-1.1V214.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30,217.4c0-1.3,0.9-2.1,1.9-2.1c1,0,1.9,0.8,1.9,2.1c0,1.3-0.9,2.1-1.9,2.1C31,219.4,30,218.7,30,217.4z  M32.6,217.4c0-0.6-0.2-1.1-0.7-1.1s-0.7,0.4-0.7,1.1c0,0.7,0.2,1.1,0.7,1.1S32.6,218,32.6,217.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.7,215.4h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4H37v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.1,214.2c0-0.4,0.3-0.6,0.7-0.6c0.4,0,0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6 C39.4,214.9,39.1,214.6,39.1,214.2z M39.2,215.4h1.2v3.9h-1.2V215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.6,217.9v-1.5h-0.5v-0.9l0.6,0l0.1-1.2h1v1.2h0.9v1h-0.9v1.5c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1 l0.2,0.9c-0.2,0.1-0.5,0.2-0.9,0.2C42,219.4,41.6,218.8,41.6,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.1,217.4c0-1.3,0.9-2.1,1.9-2.1c1,0,1.9,0.8,1.9,2.1c0,1.3-0.9,2.1-1.9,2.1 C45.1,219.4,44.1,218.7,44.1,217.4z M46.7,217.4c0-0.6-0.2-1.1-0.7-1.1c-0.5,0-0.7,0.4-0.7,1.1c0,0.7,0.2,1.1,0.7,1.1 C46.5,218.4,46.7,218,46.7,217.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.8,215.4h1l0.1,0.7h0c0.3-0.5,0.7-0.8,1.1-0.8c0.2,0,0.4,0,0.5,0.1l-0.2,1c-0.1,0-0.2,0-0.4,0 c-0.3,0-0.6,0.2-0.9,0.7v2.2h-1.2V215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.9,214.2c0-0.4,0.3-0.6,0.7-0.6s0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6S51.9,214.6,51.9,214.2z M52,215.4 h1.2v3.9H52V215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.2,215.4h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.5,220c0-0.3,0.2-0.6,0.6-0.8v0c-0.2-0.1-0.4-0.3-0.4-0.7c0-0.3,0.2-0.6,0.4-0.7v0c-0.3-0.2-0.5-0.6-0.5-1 c0-1,0.8-1.4,1.6-1.4c0.2,0,0.4,0,0.6,0.1h1.4v0.9h-0.6c0.1,0.1,0.1,0.3,0.1,0.5c0,0.9-0.7,1.3-1.6,1.3c-0.1,0-0.3,0-0.5-0.1 c-0.1,0.1-0.1,0.1-0.1,0.3c0,0.2,0.2,0.3,0.6,0.3h0.6c1,0,1.5,0.3,1.5,1c0,0.8-0.9,1.4-2.2,1.4C59.2,221,58.5,220.7,58.5,220z  M61.2,219.8c0-0.2-0.2-0.3-0.6-0.3h-0.4c-0.3,0-0.4,0-0.6,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.3,0.3,0.4,0.8,0.4 C60.8,220.2,61.2,220,61.2,219.8z M60.7,216.7c0-0.4-0.2-0.6-0.5-0.6c-0.3,0-0.5,0.2-0.5,0.6c0,0.4,0.2,0.6,0.5,0.6 C60.5,217.4,60.7,217.1,60.7,216.7z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 43.2,
    y1: 226.9,
    x2: 43.2,
    y2: 241.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 43.2,
    y1: 226.9,
    x2: 43.2,
    y2: 236.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "41.7,235.8 43.2,241.6 44.8,235.8  "
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.2,261.2H7.3c-3.5,0-6.3-2.8-6.3-6.3v-7.1c0-3.5,2.8-6.3,6.3-6.3h71.9c3.5,0,6.3,2.8,6.3,6.3v7.1 C85.5,258.4,82.7,261.2,79.2,261.2z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.8,248.6h1.3l0.8,2.2c0.1,0.3,0.2,0.6,0.3,0.9h0c0.1-0.3,0.2-0.6,0.3-0.9l0.8-2.2h1.3v5.1h-1.1v-1.8 c0-0.5,0.1-1.4,0.2-1.9h0l-0.4,1.3l-0.7,1.9h-0.7l-0.7-1.9L9.8,250h0c0.1,0.5,0.2,1.4,0.2,1.9v1.8H8.8V248.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.6,252.6c0-0.8,0.6-1.3,2.2-1.4c0-0.3-0.2-0.5-0.6-0.5c-0.3,0-0.6,0.1-1,0.3l-0.4-0.8 c0.5-0.3,1.1-0.5,1.7-0.5c1,0,1.6,0.6,1.6,1.8v2.2h-1l-0.1-0.4h0c-0.3,0.3-0.7,0.5-1.1,0.5C15,253.8,14.6,253.3,14.6,252.6z  M16.8,252.5v-0.6c-0.8,0.1-1,0.3-1,0.6c0,0.2,0.2,0.3,0.4,0.3C16.4,252.9,16.6,252.7,16.8,252.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.9,249.8h1l0.1,0.7h0c0.3-0.5,0.7-0.8,1.1-0.8c0.2,0,0.4,0,0.5,0.1l-0.2,1c-0.1,0-0.2,0-0.4,0 c-0.3,0-0.6,0.2-0.9,0.7v2.2h-1.2V249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.1,248.2h1.2v3.1h0l1.2-1.5h1.3l-1.4,1.6l1.5,2.3h-1.3l-0.9-1.5l-0.5,0.5v1h-1.2V248.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.1,251.7c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5h-2.3c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C26.9,253.8,26.1,253,26.1,251.7z M28.6,251.3c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.5,252.3v-1.5H30v-0.9l0.6,0l0.1-1.2h1v1.2h0.9v1h-0.9v1.5c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1 l0.2,0.9c-0.2,0.1-0.5,0.2-0.9,0.2C30.9,253.8,30.5,253.2,30.5,252.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.8,251.2c0-1.7,1.2-2.7,2.5-2.7c0.7,0,1.2,0.3,1.6,0.7l-0.6,0.7c-0.3-0.2-0.5-0.4-0.9-0.4 c-0.7,0-1.2,0.6-1.2,1.6c0,1,0.5,1.6,1.2,1.6c0.4,0,0.7-0.2,1-0.4l0.6,0.7c-0.5,0.5-1,0.8-1.7,0.8 C35.9,253.8,34.8,252.9,34.8,251.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.4,251.7c0-1.3,0.9-2.1,1.9-2.1c1,0,1.9,0.8,1.9,2.1c0,1.3-0.9,2.1-1.9,2.1C40.3,253.8,39.4,253,39.4,251.7 z M42,251.7c0-0.6-0.2-1.1-0.7-1.1s-0.7,0.4-0.7,1.1c0,0.7,0.2,1.1,0.7,1.1S42,252.4,42,251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44,249.8h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6H44V249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,249.8h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.9,251.7c0-1.3,0.9-2.1,1.9-2.1c1.1,0,1.7,0.8,1.7,1.9c0,0.2,0,0.4,0,0.5H54c0.1,0.5,0.5,0.8,1,0.8 c0.3,0,0.6-0.1,0.8-0.2l0.4,0.7c-0.4,0.3-0.9,0.4-1.4,0.4C53.7,253.8,52.9,253,52.9,251.7z M55.4,251.3c0-0.4-0.2-0.7-0.6-0.7 c-0.3,0-0.6,0.2-0.7,0.7H55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57,251.7c0-1.3,1-2.1,2.1-2.1c0.5,0,0.9,0.2,1.1,0.4l-0.6,0.8c-0.2-0.1-0.3-0.2-0.5-0.2 c-0.5,0-0.9,0.4-0.9,1.1c0,0.7,0.4,1.1,0.8,1.1c0.3,0,0.5-0.1,0.7-0.2l0.5,0.8c-0.4,0.3-0.9,0.5-1.3,0.5 C57.8,253.8,57,253,57,251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61,252.3v-1.5h-0.5v-0.9l0.6,0l0.1-1.2h1v1.2h0.9v1h-0.9v1.5c0,0.4,0.2,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1 l0.2,0.9c-0.2,0.1-0.5,0.2-0.9,0.2C61.4,253.8,61,253.2,61,252.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.8,248.6c0-0.4,0.3-0.6,0.7-0.6s0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6S63.8,249,63.8,248.6z M63.9,249.8 h1.2v3.9h-1.2V249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,251.7c0-1.3,0.9-2.1,1.9-2.1c1,0,1.9,0.8,1.9,2.1c0,1.3-0.9,2.1-1.9,2.1C66.8,253.8,65.9,253,65.9,251.7 z M68.5,251.7c0-0.6-0.2-1.1-0.7-1.1c-0.5,0-0.7,0.4-0.7,1.1c0,0.7,0.2,1.1,0.7,1.1C68.3,252.8,68.5,252.4,68.5,251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.5,249.8h1l0.1,0.5h0c0.3-0.3,0.7-0.6,1.3-0.6c0.9,0,1.2,0.6,1.2,1.6v2.4h-1.2v-2.3c0-0.5-0.1-0.7-0.5-0.7 c-0.3,0-0.4,0.1-0.7,0.4v2.6h-1.2V249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.7,253.2l0.5-0.7c0.4,0.3,0.7,0.4,1,0.4c0.3,0,0.5-0.1,0.5-0.3c0-0.2-0.3-0.3-0.8-0.5c-0.6-0.2-1-0.6-1-1.2 c0-0.7,0.6-1.2,1.5-1.2c0.6,0,1.1,0.2,1.4,0.5l-0.5,0.7c-0.3-0.2-0.6-0.3-0.8-0.3c-0.3,0-0.4,0.1-0.4,0.3c0,0.2,0.2,0.3,0.7,0.5 c0.6,0.2,1.1,0.5,1.1,1.2c0,0.7-0.6,1.3-1.6,1.3C75.7,253.8,75.1,253.6,74.7,253.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliProcess);
export default __webpack_public_path__ + "static/media/SLI_process.1e05e353d3e2d53b59bdbb903ad902a8.svg";
export { ForwardRef as ReactComponent };